import { FC } from 'react'
import styled from 'styled-components'
import { rawSvgIcons } from './rawSvgIcons'
import { Box } from '../UI/Box'
import { defaultTransition } from '../../theme'
import { Project } from '../../page_components/PoolDetails/Missions/types'

const Container = styled(Box)`
  width: 100%;
  min-height: 48px;
  @media screen and (max-width: 600px) {
    width: auto;
    flex: 0;
    margin: 0;
    max-width: calc(100vw - 64px);
    justify-content: space-between;
    top: 0;
  }
`

const Link = styled.a`
  cursor: pointer;
  @media screen and (max-width: 600px) {
    margin: 0 4px;
  }
`

const B2BIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: #000;
  border: 1px solid rgba(255, 255, 255, 0.12);
  overflow: hidden;
  border-radius: 8px;
  svg {
    width: 44px;
    height: auto;
  }

  ${defaultTransition}
  :hover {
    transform: scale(1.1);
  }
`

const acceptedSocials = [
  'twitter',
  'youtube',
  'instagram',
  'twitch',
  // 'tiktok',
  // 'facebook',
  'spotify',
  'discordUrl',
  'telegram',
  'newsletter',
]

interface Props {
  project: Project
}

const ProjectLinks: FC<Props> = ({ project }) => {
  const links = project?.socials

  if (!links) return <></>

  const linksLength = Object.keys(links).filter(
    (key) => key !== 'id' && !!links[key],
  ).length

  if (!linksLength) return <></>

  return (
    <Container g={12}>
      {links &&
        Object.keys(links)
          .filter(
            (key) =>
              links[key] && key !== 'id' && acceptedSocials.includes(key),
          )
          .map((key, i) => {
            // some socials, like discord/youtube we have two fields:
            // one for url like "discordUrl" and another for validation like "discordId" or "youtube" (handle)
            const accountHandleOrUrl = links[key]
            const rawIcon = rawSvgIcons?.[key.replace('Url', '')]

            if (!accountHandleOrUrl) return <></>
            const url = makeUrlFromAccountHandleOrUrl(accountHandleOrUrl, key)
            if (!rawIcon || !url) return <></>
            return (
              <Link
                href={url}
                target="_blank"
                rel="noreferrer"
                key={`project-link-${i}`}
              >
                <B2BIcon key={`project-link-${i}`}>
                  <Box c dangerouslySetInnerHTML={{ __html: rawIcon }} />
                </B2BIcon>
              </Link>
            )
          })}
    </Container>
  )
}

export default ProjectLinks

function makeUrlFromAccountHandleOrUrl(
  accountHandleOrUrl: string,
  type: string,
) {
  const isUrl = accountHandleOrUrl.includes('http')
  if (isUrl) return accountHandleOrUrl

  if (type === 'twitter') {
    return `https://twitter.com/${accountHandleOrUrl}`
  }
  if (type === 'instagram') {
    return `https://instagram.com/${accountHandleOrUrl}`
  }
  if (type === 'tiktok') {
    return `https://tiktok.com/@${accountHandleOrUrl}`
  }
  if (type === 'youtube') {
    return `https://youtube.com/@${accountHandleOrUrl}`
  }
  if (type === 'facebook') {
    return `https://facebook.com/${accountHandleOrUrl}`
  }
  if (type === 'spotify') {
    return `https://open.spotify.com/user/${accountHandleOrUrl}`
  }
  if (type === 'twitch') {
    return `https://twitch.tv/${accountHandleOrUrl}`
  }
  if (type === 'telegram') {
    return `https://t.me/${accountHandleOrUrl}`
  }
  if (type === 'newsletter') {
    return accountHandleOrUrl
  }
  return ''
}
